import { debounce, DebouncedFunc, isNil } from 'lodash';
import { i18n, tHtml } from '@/utils/i18n';
import { getNowTimeUsingUserdataNow, getTimeAsKst, getMobileOS, getSeviceEnv } from './utils';
import { parsePhoneNumber, formatNumber } from 'libphonenumber-js';
import { device } from '@/components/modules/common/module';

const { t } = i18n;

/*
-- EMAIL --
DISABLE_CERTIFICATION_BY_EMAIL_LIMIT
"preorder.emailCertificationLog.DISABLE_CERTIFICATION_BY_EMAIL_LIMIT": "동일 메일로 인증 시도가 계속되어 인증번호 발송이 차단되었습니다. 24시간 이후 다시 시도해 주세요",

DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT
"preorder.emailCertificationLog.DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT": "동일 이메일 주소로 인증 시도가 계속되어 인증메일 발송이 차단되었습니다. 24시간 이후 다시 시도해 주세요.",

EXPIRED_COUNT_TARGET_CERTIFICATION_BY_EMAIL
"preorder.emailCertificationLog.EXPIRED_COUNT_TARGET_CERTIFICATION": "동일 인증번호로 인증 실패가 계속되어 인증번호 발송이 차단되었습니다.",

EXPIRED_DATE_TARGET_CERTIFICATION_BY_EMAIL
"preorder.emailCertificationLog.EXPIRED_DATE_TARGET_CERTIFICATION": "인증번호 입력시간이 초과되었습니다. 다시 시도해주세요",

INVALID_CODE_TARGET_CERTIFICATION_BY_EMAIL
"preorder.emailCertificationLog.INVALID_CODE_TARGET_CERTIFICATION": "인증번호가 올바르지 않습니다.",

"preorder.emailCertificationLog.NOT_EXIST_TARGET_CERTIFICATION": "인증을 다시 시도해 주세요.",

-- PHONE --
DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT
"preorder.phoneNumberCertificationLog.DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT": "동일 번호로 인증 시도가 계속되어 인증번호 발송이 차단되었습니다. 24시간 이후 다시 시도해 주세요.",

DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT
"preorder.phoneNumberCertificationLog.DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT": "동일 IP로 인증 시도가 계속되어 인증번호 발송이 차단되었습니다. 24시간 이후 다시 시도해 주세요.",

EXPIRED_COUNT_TARGET_CERTIFICATION
"preorder.phoneNumberCertificationLog.EXPIRED_COUNT_TARGET_CERTIFICATION": "동일 인증번호로 인증 실패가 계속되어 인증번호 발송이 차단되었습니다.",

EXPIRED_DATE_TARGET_CERTIFICATION
"preorder.phoneNumberCertificationLog.EXPIRED_DATE_TARGET_CERTIFICATION": "인증번호 입력시간이 초과되었습니다. 다시 시도해주세요",

INVALID_CODE_TARGET_CERTIFICATION
"preorder.phoneNumberCertificationLog.INVALID_CODE_TARGET_CERTIFICATION": "인증번호가 올바르지 않습니다.",

"preorder.phoneNumberCertificationLog.NOT_EXIST_TARGET_CERTIFICATION": "인증을 다시 시도해 주세요.",

-- BOTH --
EMAIL_EXISTS_BUT_DIFF_STORE
"preorder.preOrderRecord.EMAIL_EXISTS_BUT_DIFF_STORE": "다른 스토어로 사전예약 신청이 완료된 이메일 주소입니다. \n스토어를 변경하시겠습니까?",

EXISTS_BUT_DIFF_STORE
"preorder.preOrderRecord.EXISTS_BUT_DIFF_STORE": "다른 스토어로 사전예약 신청이 완료된 휴대전화입니다. \n스토어를 변경하시겠습니까?",

ALREADY_EXISTS_EMAIL
"preorder.preOrderRecord3.ALREADY_EXISTS_EMAIL": "이미 등록된 이메일 입니다.",

ALREADY_EXISTS_PHONENUMBER
"preorder.preOrderRecord.ALREADY_EXISTS_PHONENUMBER": "사전예약을 완료한 핸드폰 번호입니다.",

NOT_EXISTS_PHONENUMBER
"preorder.preOrderRecord.NOT_EXISTS_PHONENUMBER": "먼저 사전예약을 완료해주세요.",

BLOCKED_IP
"preorder.preOrderBaseInfo.BLOCKED_IP": "사전예약 신청이 제한된 IP입니다.",

"preorder.preOrderRecord.NOT_COUPON_SCHEDULE" : "사전예약 쿠폰 조회 기간이 아닙니다."

-- RDS --
"NEED_CAPTCHA": 약한 rds(캡차 필요), BOT으로 판단한 경우
"preorder.preOrderRecord.NEED_CAPTCHA":

"CAPTCHA_FAILED": 약한 rds(캡차 통과X), 전달받은 캡차 response를 구글에서 캡차 실패로 판단한 경우
"preorder.preOrderRecord.CAPTCHA_FAILED": "인증 실패가 계속되어 사전예약이 차단되었습니다."

"TOO_MANY_REQUEST": 강한 rds
"preorder.preOrderRecord.TOO_MANY_REQUEST": "사전예약 신청 시도가 계속되어 사전예약이 차단되었습니다."

"INVALID_DOMAIN": 일회성 이메일 도메인
"preorder.preOrderRecord.INVALID_DOMAIN": "사용할 수 없는 이메일 주소입니다."
*/
export const EXPIRED_COUNT_TARGET_CERTIFICATION_BY_EMAIL =
  'preorder.emailCertificationLog.EXPIRED_COUNT_TARGET_CERTIFICATION';
export const EXPIRED_DATE_TARGET_CERTIFICATION_BY_EMAIL =
  'preorder.emailCertificationLog.EXPIRED_DATE_TARGET_CERTIFICATION';
export const DISABLE_CERTIFICATION_BY_EMAIL_LIMIT =
  'preorder.emailCertificationLog.DISABLE_CERTIFICATION_BY_EMAIL_LIMIT';
export const DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT =
  'preorder.emailCertificationLog.DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT';
export const INVALID_CODE_TARGET_CERTIFICATION_BY_EMAIL =
  'preorder.emailCertificationLog.INVALID_CODE_TARGET_CERTIFICATION';

export const EXPIRED_COUNT_TARGET_CERTIFICATION =
  'preorder.phoneNumberCertificationLog.EXPIRED_COUNT_TARGET_CERTIFICATION';
export const EXPIRED_DATE_TARGET_CERTIFICATION =
  'preorder.phoneNumberCertificationLog.EXPIRED_DATE_TARGET_CERTIFICATION';
export const DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT =
  'preorder.phoneNumberCertificationLog.DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT';
export const DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT =
  'preorder.phoneNumberCertificationLog.DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT';
export const INVALID_CODE_TARGET_CERTIFICATION =
  'preorder.phoneNumberCertificationLog.INVALID_CODE_TARGET_CERTIFICATION';

export const BLOCKED_IP = 'preorder.preOrderBaseInfo.BLOCKED_IP';
export const ALREADY_EXISTS_PHONENUMBER = 'preorder.preOrderRecord.ALREADY_EXISTS_PHONENUMBER';
export const ALREADY_EXISTS_EMAIL = 'preorder.preOrderRecord3.ALREADY_EXISTS_EMAIL';
export const EXISTS_BUT_DIFF_STORE = 'preorder.preOrderRecord.EXISTS_BUT_DIFF_STORE';
export const EMAIL_EXISTS_BUT_DIFF_STORE = 'preorder.preOrderRecord.EMAIL_EXISTS_BUT_DIFF_STORE';
export const NOT_EXISTS_PHONENUMBER = 'preorder.preOrderRecord.NOT_EXISTS_PHONENUMBER';
export const NOT_EXISTS_EMAIL = 'preorder.preOrderRecord3.NOT_EXISTS_EMAIL';

export const NEED_CAPTCHA = 'preorder.preOrderRecord.NEED_CAPTCHA';
export const CAPTCHA_FAILED = 'preorder.preOrderRecord.CAPTCHA_FAILED';
export const TOO_MANY_REQUEST = 'preorder.preOrderRecord.TOO_MANY_REQUEST';
export const INVALID_DOMAIN = 'preorder.preOrderRecord3.INVALID_DOMAIN';

// 사전예약용 에러코드인지?
export const isExistErrorCode = (errorCode: string | null | undefined): boolean => {
  let flag = false;
  switch (errorCode) {
    case BLOCKED_IP:
    case ALREADY_EXISTS_PHONENUMBER:
    case EXISTS_BUT_DIFF_STORE:
    case EMAIL_EXISTS_BUT_DIFF_STORE:
    case NOT_EXISTS_PHONENUMBER:
    case INVALID_CODE_TARGET_CERTIFICATION:
    case DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT:
    case DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT:
    case EXPIRED_COUNT_TARGET_CERTIFICATION:
    case EXPIRED_COUNT_TARGET_CERTIFICATION_BY_EMAIL:
    case DISABLE_CERTIFICATION_BY_EMAIL_LIMIT:
    case DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT:
    case NEED_CAPTCHA:
    case CAPTCHA_FAILED:
    case TOO_MANY_REQUEST:
    case INVALID_DOMAIN:
    case NOT_EXISTS_EMAIL:
      flag = true;
      break;
    default:
      break;
  }
  return flag;
};

// 사전예약 조회용 에러코드인지?
export const isExistErrorCodeInSearch = (errorCode: string | null | undefined): boolean => {
  let flag = false;
  switch (errorCode) {
    case BLOCKED_IP:
    case NOT_EXISTS_EMAIL:
    case NOT_EXISTS_PHONENUMBER:
    case INVALID_CODE_TARGET_CERTIFICATION:
    case EXPIRED_COUNT_TARGET_CERTIFICATION:
    case EXPIRED_COUNT_TARGET_CERTIFICATION_BY_EMAIL:
    case DISABLE_CERTIFICATION_BY_EMAIL_LIMIT:
    case DISABLE_CERTIFICATION_BY_PHONENUMBER_LIMIT:
    case DISABLE_CERTIFICATION_BY_REMOTE_ADDR_LIMIT:
    case DISABLE_CREATE_CERTIFICATION_BY_EMAIL_LIMIT:
      flag = true;
      break;
    default:
      break;
  }
  return flag;
};

// 수정이 필요
let hasVisualViewportEvent: boolean = false;
export const closeKeyboardScroll = (
  initInnerHeight: number
): {
  addVisualViewportEvent: (preorderStep?: number) => void;
  removeViewpointEventHandler: () => void;
} => {
  let _visualViewportEventHandler: DebouncedFunc<() => void>;

  /* 키보드가 닫힐때 사전예약 모듈로 스크롤하기 */
  const visualViewportEventHandler = (fullInnerHeight?: number, preorderStep?: number): void => {
    const visualViewport =
      getMobileOS() === 'ios' ? window.visualViewport?.height || 0 : fullInnerHeight;
    if (window.innerHeight === visualViewport) {
      // 스크롤 닫힐때 이벤트 제거
      scrollToPreorder(visualViewport, preorderStep !== 1);
      removeViewpointEventHandler();
      hasVisualViewportEvent = false;
    }
  };

  // 이벤트 등록
  const addVisualViewportEvent = (preorderStep?: number): void => {
    if (hasVisualViewportEvent) return;
    hasVisualViewportEvent = true;
    _visualViewportEventHandler = debounce(
      () => visualViewportEventHandler(initInnerHeight, preorderStep),
      100
    );
    window.visualViewport?.addEventListener('resize', _visualViewportEventHandler);
  };

  // 이벤트 삭제
  const removeViewpointEventHandler = (): void => {
    hasVisualViewportEvent = false;
    window.visualViewport?.removeEventListener('resize', _visualViewportEventHandler);
  };

  return { addVisualViewportEvent, removeViewpointEventHandler };
};

// 사전예약 모듈로 스크롤 이동하기
// 스크롤 도중 입력하면 스크롤이 멈추는 현상
export const scrollToPreorder = async (
  viewport?: number | undefined,
  useScrollIntoTop: boolean = true
): Promise<void> => {
  const preorder = document.querySelector('#preorder') as HTMLElement;
  // 사전예약 모듈의 top 절대 좌표:  window.scrollY + preorder?.getBoundingClientRect().top
  // 사전에약 모듈 + CTA 버튼 height: preorder?.clientHeight + 70
  // 사전예약 모듈 viewport내에서 top기준 떨어져있는 정도 : window.innerHeight - (preorder?.clientHeight + 70)
  const _viewport = viewport ? viewport : window.innerHeight;

  // const viewPort = viewport || window.visualViewport?.height || 0;
  // const offsetPosition =
  //   window.scrollY +
  //   preorder?.getBoundingClientRect().top -
  //   (viewPort - (preorder?.clientHeight + 70));

  setTimeout(() => {
    let offsetPosition: number;
    let scroll = '';
    if (useScrollIntoTop) {
      offsetPosition = window.scrollY + preorder?.getBoundingClientRect().top;
      scroll = 'scrollToTop';
    } else {
      offsetPosition =
        window.scrollY +
        preorder?.getBoundingClientRect().top -
        (_viewport - (preorder?.clientHeight + 70));
      scroll = 'scrollToBottom';
    }

    if (offsetPosition === window.scrollY) return;
    // console.log(scroll);
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }, 100);
};

// 한국어 입력 막기
// 바뀐 text값 전달
export const preventKorean = (event: Event): string => {
  const koreanExp = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;
  const target = (event.target as HTMLInputElement).value;
  // 입력창에 한국어 입력을 막기
  (event.target as HTMLInputElement).value = target.replace(koreanExp, '');
  // 변경된 input 값 전달
  return (event.target as HTMLInputElement).value;
};
// Input창 숫자만 입력 가능
export const onlyNumberInInput = (event: KeyboardEvent): void => {
  // ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const numberList = Array.from({ length: 10 }, (_, i) => i.toString());
  const keyCode = event.key || event.keyCode;

  if (typeof keyCode === 'string') {
    if (!numberList.includes(keyCode)) event.preventDefault();
  } else if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    event.preventDefault();
  }
};

// 만나이 계산
const _getOriginAge = (year: string, day: string, month: string): number => {
  const today = new Date();
  const birthDate = new Date(parseInt(year), parseInt(month), parseInt(day));
  let age = today.getFullYear() - birthDate.getFullYear();
  let mon = today.getMonth() + 1 - birthDate.getMonth();
  if (mon < 0 || (mon === 0 && today.getDate() < birthDate.getDate())) {
    return (age = age - 1);
  } else {
    return age;
  }
};

// 현재 시간 계산
export const getCurrentDate = (): { year: number; month: string; date: string } => {
  const today = new Date();
  const year = today.getFullYear();
  const month =
    (today.getMonth() + 1).toString().length < 2
      ? `0${today.getMonth() + 1}`
      : (today.getMonth() + 1).toString();
  const date =
    today.getDate().toString().length < 2 ? `0${today.getDate()}` : today.getDate().toString();
  return { year, month, date };
};

// 휴대폰, 이메일 패턴 체크
export const patternCheck = (number: string, regex: RegExp): boolean => {
  return regex.test(number);
};

// 문자열 byte수 체크
const _getByteLengthOfString = (str: string): number => {
  return str
    .split('')
    .map((s) => s.charCodeAt(0))
    .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
};

// 입력받은 연도의 포맷 체크
const _isCorrectYearFormat = (val: string): boolean => {
  return /^(19|20)\d{2}$/g.test(val);
};
// 입력받은 월의 포맷 체크
const _isCorrectMonthFormat = (monthValue: string): boolean => {
  return /^(0[1-9]|1[012])$/g.test(monthValue);
};
// 입력받은 일의 포맷 체크
const _isCorrectDayFormat = (dayValue: string): boolean => {
  return /^(0[1-9]|[12][0-9]|3[0-1])$/g.test(dayValue);
};

// 월과 일을 통해 해당 월에 해당 일이 있는지 확인
const _checkMaxDayInTheMonth = (
  yearValue: string,
  monthValue: string,
  dayValue: string
): boolean => {
  const year = parseInt(yearValue);
  const isLeapYear = (year % 4 == 0 && year % 100 != 0) || year % 400 == 0; // 윤년 체크
  const _monthValue = parseInt(monthValue);
  const _dayValue = parseInt(dayValue);
  switch (_monthValue) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      if (_dayValue > 31) return false;
      break;
    case 4:
    case 6:
    case 9:
    case 11:
      if (_dayValue > 30) return false;
      break;
    case 2:
      // 윤년일 때는 29일 보다 크거나
      // 윤년이 아닐때 29일 이상일 때
      if ((isLeapYear && _dayValue > 29) || (!isLeapYear && _dayValue >= 29)) return false;
      break;
  }

  return true;
};

// 생년월일 입력폼 유효성 검사
export const validateForBirthDay = (
  year: string,
  month: string,
  day: string,
  ageLimit: number,
  focusYearTarget: HTMLInputElement | null,
  focusMonthTarget: HTMLInputElement | null,
  focusDayTarget: HTMLInputElement | null,
  preventScroll: boolean
) => {
  if (year.length === 0 || year.length < 4) {
    focusYearTarget?.focus({ preventScroll: preventScroll });
    // focusYearTarget?.setSelectionRange(0, 0);
    return t('preorder.record.error.birth_blank');
  } else if (month.length === 0 || month.length < 2) {
    focusMonthTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_blank');
  } else if (day.length === 0 || day.length < 2) {
    focusDayTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_blank');
  } else if (!_isCorrectYearFormat(year)) {
    // 연도 패턴 체크
    focusYearTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_pattern', { age: ageLimit });
  } else if (!_isCorrectMonthFormat(month)) {
    // 월 패턴 체크
    focusMonthTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_pattern', { age: ageLimit });
  } else if (!_isCorrectDayFormat(day)) {
    // 일 패턴 체크
    focusDayTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_pattern', { age: ageLimit });
  } else if (!_checkMaxDayInTheMonth(year, month, day)) {
    // 연도, 월, 일 비교해서 올바른지 체크
    focusDayTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.birth_pattern', { age: ageLimit });
  } else if (_getOriginAge(year, day, month) < ageLimit) {
    // 만나이 체크
    focusYearTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.age_invalid', { age: ageLimit });
  }
  return '';
};

// 입력창 유효성 검사
// 휴대폰 입력칸이 빈칸이거나, 올바른 휴대전화 폼이 아닐때
export const validateForPhoneNumber = (
  errorTarget: string,
  phonePattern: RegExp,
  focusTarget: HTMLInputElement | null,
  preventScroll?: boolean
) => {
  if (errorTarget.length === 0) {
    // 휴대전화 입력
    focusTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.phone_blank');
  } else if (!patternCheck(errorTarget, phonePattern)) {
    // 휴대전화 (정규식) 확인
    focusTarget?.focus({ preventScroll: preventScroll });
    return t('preorder.record.error.phone_pattern');
  }
  return '';
};

// 이메일 유효성 검사
// 이메일이 64byte가 넘거나, 올바른 이메일 형식이 아닐때
export const validateForEmail = (
  errorTarget: string,
  emailPattern: RegExp,
  focusTarget: HTMLInputElement | null,
  isOptional: boolean = false,
  preventScroll?: boolean
) => {
  if (!isOptional && errorTarget.length === 0) {
    setTimeout(() => focusTarget?.focus({ preventScroll: preventScroll }));
    return t('preorder.record.error.email_blank');
  } else if (!patternCheck(errorTarget, emailPattern)) {
    setTimeout(() => focusTarget?.focus({ preventScroll: preventScroll }));
    return t('preorder.record.error.email_pattern');
  } else if (_getByteLengthOfString(errorTarget) >= 64) {
    setTimeout(() => focusTarget?.focus({ preventScroll: preventScroll }));
    return t('preorder.record.error.email_pattern');
  }
  return '';
};

// 인증번호 유효성 검사
// 인증번호를 입력하지 않거나 6자리 이하일 때
export const validateForCertificationCode = (
  errorTarget: string,
  focusTarget: HTMLInputElement | null,
  preventScroll?: boolean
): string => {
  if (errorTarget.length === 0) {
    setTimeout(() => focusTarget?.focus({ preventScroll: preventScroll }));
    return t('preorder.record.error.certification_blank');
  } else if (errorTarget.length < 6) {
    setTimeout(() => focusTarget?.focus({ preventScroll: preventScroll }));
    return t('preorder.record.error.certification_pattern');
  }
  return '';
};

// 타이머 시각 포메팅
// 600 > 10:00
export const formattingTime = (totalTime: number): string => {
  const time = totalTime / 60;
  const min = Math.floor(time);
  const sec = Math.round((time - min) * 60);
  return min.toString().padStart(2, '0') + ':' + sec.toString().padStart(2, '0');
};

// 현재 한국 번호만 대응
// +821012345678
// countryCode: 국가코드(82),
// nationalNumber: 01012345678,
// areaCode: 지역코드(010),
// withOutAreAcodeNumberL 지역코드를 제외한 번호(12345678)
export const formattingInternationalNumber = (phoneNumber: string) => {
  const nationalNumberWithDash = formatNumber(phoneNumber, 'NATIONAL'); // 010-1234-5678
  const nationalNumber = nationalNumberWithDash.split('-').join('');
  const areaCode = nationalNumberWithDash.split('-')[0];
  const withOutAreaCodeNumber =
    nationalNumberWithDash.split('-')[1] + nationalNumberWithDash.split('-')[2];
  const countryCode = parsePhoneNumber(phoneNumber).countryCallingCode; // {}

  return { nationalNumber, countryCode, areaCode, withOutAreaCodeNumber };
};

// ----------------------
// 휴대폰 (한국)
// 01012345678 > 010-12**-34**
// 0101234567 > 010-1**-45**

// 휴대폰 (대만)
// 0935 555 888 > 0935-**5-8**

// 이메일 ncosft@naver.com
// 4자리이상 앞 2자리 뺴고 마스킹 nc****@naver.com
// 3자리면 끝2자리 마스킹 n**@naver.com
// 2자리 끝 1자리 마스킹 n*@naver.com
// 1자리 모두 마스킹 *@naver.com

export const maskingUserInfo = (
  phoneNumber: string,
  email: string,
  isTaiwan: boolean = false
): string => {
  let formatInfo = '';
  if (phoneNumber) {
    if (isTaiwan) {
      const firstNumber = phoneNumber.slice(0, 4);
      const secondNumber = phoneNumber.slice(4, 7);
      const thirdNumber = phoneNumber.slice(7, 11);
      formatInfo = `${firstNumber}-**${secondNumber.substring(2, 3)}-${thirdNumber.substring(
        0,
        1
      )}**`;
    } else {
      const firstNumber = phoneNumber.slice(0, 3);
      const secondNumber =
        phoneNumber.length === 11 ? phoneNumber.slice(3, 7) : phoneNumber.slice(3, 6);
      const thirdNumber = phoneNumber.length === 11 ? phoneNumber.slice(7) : phoneNumber.slice(6);

      formatInfo = `${firstNumber}-${secondNumber.substring(
        0,
        phoneNumber.length === 11 ? 2 : 1
      )}**-${thirdNumber.substring(0, 2)}**`;
    }
  } else if (email) {
    const emailId = email.split('@')[0];
    let len;
    if (emailId.length >= 4) {
      len = emailId.length - 3;
    } else if (emailId.length === 3) {
      len = 1;
    } else if (emailId.length === 2 || emailId.length === 1) {
      len = 0;
    }
    formatInfo = email.replace(new RegExp(`.(?=.{0,${len}}@)`, 'g'), '*');
  }
  return formatInfo;
};

// extraData에 넘어온 coupon번호 포매팅
// extraData = ",couponNo=RW81SK544HYXR0XU:qi6y^5AVADMQ991CNWCD7:qi6x,"
export interface CouponList {
  name: string;
  id: string;
}
export const formatCouponList = (extraData: string): CouponList[] | null => {
  let formatCouponList: CouponList[] = [];
  // couponNo 위치에서 뒤에값만 가져와 ^로 split
  if (extraData.indexOf('couponNo') === -1) return null;
  const findCouponNoStr = extraData.split(',').filter((i) => i.indexOf('couponNo') !== -1)[0];
  const tempCouponList = findCouponNoStr
    .slice(findCouponNoStr.indexOf('couponNo') + 'couponNo'.length + 1)
    .split('^');
  tempCouponList.forEach((tempCouponItem) => {
    const name = tempCouponItem.split(':')[1];
    const id = tempCouponItem.split(':')[0];
    formatCouponList.push({ name, id });
  });
  return formatCouponList;
};

// 현재 시간이 쿠폰등록 활성화 시간인지 체크
export const isInCouponRegistTime = (
  couponRegistStartTime?: string,
  couponRegistEndTime?: string,
  isAdmin: boolean = false
) => {
  // 현재 시간 = 페이지 진입시점의 서버 시간 + 이 함수가 호출 될때까지 지난 시간
  const nowTime = isAdmin ? null : getNowTimeUsingUserdataNow();
  // userData.now 가 없거나 운영툴에 설정된 쿠폰등록 활성화 시간이 없으면 일단 무조건 true -> 쿠폰 등록 기간으로 본다.
  if (isNil(nowTime) || !couponRegistStartTime || !couponRegistEndTime) return true;
  return (
    nowTime > getTimeAsKst(couponRegistStartTime) && nowTime < getTimeAsKst(couponRegistEndTime)
  );
};

// 업데이트 필요
type Service =
  | 'tl'
  | 'lin'
  | 'linw'
  | 'lin2'
  | 'lms'
  | 'l2m'
  | 'bns'
  | 'bns2'
  | 'h3'
  | 'h2'
  | 'tr'
  | 'aion'
  | 'l2mnct';
export const getRegisterCouponLink = (service: Service, couponCode: string): string => {
  const gameKey = service;
  if (!gameKey) return '#';

  const env = getSeviceEnv();

  let shopPath;
  let shopPathNct;
  let shopPathPcgame;

  if (env === 'live') {
    shopPath = 'https://nshop.plaync.com/shop';
    shopPathNct = 'https://tw.ncsoft.com/shop';
    shopPathPcgame = 'https://store.plaync.com/wallet/kr/coupon/couponRegister';
  } else {
    shopPath = 'https://rc-nshop.plaync.com/shop';
    shopPathNct = 'https://rc-tw.ncsoft.com/shop';
    shopPathPcgame = 'https://rc-store.plaync.com/wallet/kr/coupon/couponRegister';
  }

  let href = '';
  console.log(gameKey, window.location.href.indexOf('tw.ncsoft.com'));
  switch (gameKey) {
    case 'lms':
      href = `${shopPath}/lms/kr/coupon/${couponCode}`;
      break;
    case 'bns2':
      href = `${shopPath}/bns2/kr/coupon/${couponCode}`;
      break;
    case 'h2':
      href = `${shopPath}/h2/kr/coupon/${couponCode}`;
      break;
    case 'h3':
      href = `${shopPath}/h3/kr/coupon/${couponCode}`;
      break;
    case 'l2m':
      href = `${shopPath}/l2m/kr/coupon/${couponCode}`;
      break;
    case 'tr':
      href = `${shopPath}/tricksterm/kr/coupon/${couponCode}`;
      break;
    case 'linw':
      href = `${shopPath}/linw/coupon/${couponCode}`;
      break;
    case 'l2mnct':
      href = `${shopPath}/l2m/tw/coupon/${couponCode}`;
      break;
    case 'aion':
    case 'lin2':
    case 'lin':
    case 'bns':
    case 'tl':
      href = `${shopPathPcgame}?couponKey=${couponCode}`;
      break;
    default :
      href = `${shopPathPcgame}`;

    // TODO: Add coupon link of other games
  }

  if (
    window.userData &&
    window.userData.gameAccount &&
    window.userData.gameAccount.serverId &&
    window.userData.gameAccount.name
  )
    href = `${href}?gameServerId=${window.encodeURIComponent(
      window.userData.gameAccount.serverId
    )}&charName=${window.encodeURIComponent(window.userData.gameAccount.name)}`;

  return href;
};
